//componente react per gestire il pagamento con PayPal andato a buon fine
import React from 'react';
import Page from '../layout/Page';
import Card from '../layout/Card';

export default function Success() {
    //qui mi prendo il tyoe da query string
    const queryParams = new URLSearchParams(window.location.search);
    const type = queryParams.get('type');

    return (
        <Page title={"Pagamento " + (type === "fattura" ? "della fattura" : "del pacchetto sms") + " completato con successo"} >
            <Card content={
                <div className="paypal-page">
                    <p>Grazie per il tuo pagamento! La transazione per {type === "fattura" ? "la fattura" : "il pacchetto sms"} è stata completata con successo.</p>
                    <p>Ti informiamo che sono comunque necessari alcuni giorni lavorativi per verificare lo stato del pagamento</p>
                    <a href="/" className="btn btn-primary">Torna alla Home</a>
                </div>
            } />
        </Page>
    );
}